import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

interface DeleteProfileDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  profileName: string;
}

export function DeleteProfileDialog({
  open,
  onClose,
  onConfirm,
  profileName,
}: DeleteProfileDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>تأكيد الحذف</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-gray-500">
          هل أنت متأكد من حذف الملف الشخصي لـ {profileName}؟
          <br />
          لا يمكن التراجع عن هذا الإجراء.
        </p>
        <DialogFooter className="sm:justify-start">
          <Button
            variant="destructive"
            onClick={onConfirm}
          >
            <Trash2 className="h-4 w-4 ml-2" />
            تأكيد الحذف
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            className="mr-2"
          >
            إلغاء
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}